<template>
  <div>
    <v-layout row wrap>
      <v-flex :class="isSmAndDown ? 'xs12' : 'xs6'">
        <h4 class="checkout-h4 confirmation-subtitle">Evento organizado por <strong v-if="isSmAndDown">{{ organizerInfo.organizador }}</strong></h4>
        <strong v-if="!isSmAndDown">{{ organizerInfo.organizador }}</strong>
        <br v-if="!isSmAndDown" />
        <span class="grey--text" v-if="organizerInfo.cnpj_organizador">CNPJ: {{organizerInfo.cnpj_organizador}}</span>
        <span class="grey--text" v-else-if="organizerInfo.cpf_organizador">CPF: {{organizerInfo.cpf_organizador}}</span>
      </v-flex>
      <v-spacer></v-spacer>
      <!-- <v-flex :class="isSmAndDown ? 'xs12' : 'shrink'">
    <div class="btn-next-step">
      <v-btn
        block
        round
        flat 
        outline
        class="normal-text"
        color="primary"
        target="_blank"
      >Falar com o Organizador</v-btn>
    </div>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    organizerInfo() {
      return this.$store.getters.postOrder;
    },
  },
};
</script>